export default __webpack_public_path__ + "static/media/lab5.5acb6457.jpeg";